import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/small-adu-feel-bigger.png";

const BlogSmallADUFeelBigger = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "How to Make a Small ADU Feel Bigger",
    "description": "Open layouts, natural light, and smart flow. Learn design strategies to maximize space in a small ADU.",
    "datePublished": "2026-04-05",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/small-adu-feel-bigger" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />
      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="How to make a small ADU feel bigger" className="w-full rounded-2xl" />
      </div>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Blog
        </Link>
        <p className="text-sm text-muted-foreground mb-2">April 5, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">How to Make a Small ADU Feel Bigger</h1>
        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>One of the biggest concerns homeowners have is space.</p>
          <p>How do you make a small ADU feel comfortable?</p>
          <p>The answer is not just square footage. It's how the space is designed.</p>
          <p>Open layouts, natural light, and indoor outdoor connections make a major difference. When done right, a smaller unit can feel much larger than expected.</p>
          <p>We focus on eliminating wasted space. Every area has a purpose. Every transition feels natural.</p>
          <p>A well-designed ADU does not feel like a small unit. It feels like a complete home.</p>
        </article>
        <BlogCTAButtons />
      </main>
      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogSmallADUFeelBigger;
